/**
 * Модуль деления с остатком {@link value} на {@link base}
 * @param value делимое
 * @param base делитель
 */
export const positiveMod = (value: number, base: number) => ((value % base) + base) % base;
